import { PostProcessorModule } from 'i18next';
import isObject from 'lodash/isObject';
import { getObjectKeys } from 'src/helpers/getObjectKeys';

const applyBasicPluralization = (value: string, count: number): string => {
  const pluralization = value.split('|');
  if (count === 1) {
    return pluralization[0];
  }

  return pluralization[1];
};

const formatLaravelTranslation: PostProcessorModule['process'] = (value, key, options) => {
  if (!(typeof value !== 'string')) {
    value = `${value ?? ''}`;
  }

  if (!('replace' in options) || !isObject(options.replace) || !value) {
    return value;
  }

  // Fixes CUSTOMER-WEB-APP-GS: Use split/join instead of replaceAll for broader browser compatibility
  // Note: While browserslist targets '>0.2%' (which includes replaceAll support), this fix ensures
  // compatibility with edge cases like embedded webviews, older mobile browsers, and corporate proxies
  // that may inject older JS engines. The performance difference is negligible.
  const replaced = getObjectKeys(options.replace).reduce((v, key) => {
    const placeholder = `:${key}`;
    const replacement = String(options.replace[key] ?? '');
    v = v.split(placeholder).join(replacement);
    return v;
  }, value);

  // TODO: split interpolation and pluralization logic
  const hasPluralization =
    replaced.includes('|') && 'count' in options && typeof options.count !== 'undefined';
  if (!hasPluralization) {
    return replaced;
  }

  return applyBasicPluralization(replaced, options.count!);
};

const LaravelFormatter: PostProcessorModule = {
  type: 'postProcessor',
  name: 'laravelFormatter',
  process: (...args) => formatLaravelTranslation(...args),
};

export { LaravelFormatter };
